import { render, staticRenderFns } from "./SimpleUpload.vue?vue&type=template&id=0821ad40"
import script from "./SimpleUpload.vue?vue&type=script&lang=js"
export * from "./SimpleUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports